module.exports = {
          srcSet: __webpack_public_path__ + "public/d2a5bd97af63177299197448798f0268-181.png"+" 181w",
          images:[ {path: __webpack_public_path__ + "public/d2a5bd97af63177299197448798f0268-181.png",width: 181,height: 220}],
          src: __webpack_public_path__ + "public/d2a5bd97af63177299197448798f0268-181.png",
          toString:function(){return __webpack_public_path__ + "public/d2a5bd97af63177299197448798f0268-181.png"},
          
          width: 181,
          height: 220
        }